import { CoborrowerEmployment, PrimaryBorrowerEmployment } from '../../cards/employment';
import { Branch, Card } from '../../components/deck';
import EmploymentInfoBranch from './employment-info';

const employment = {
  borrower: PrimaryBorrowerEmployment,
  coborrower: CoborrowerEmployment
};

export default (borrowerKey, continuation) =>
  Card(
    employment[borrowerKey],
    Branch(
      {
        w2Branch: EmploymentInfoBranch(borrowerKey)
      },
      ({ model }) => {
        let employment = model.getIn([borrowerKey, 'employment']);
        if (Array.isArray(employment)) {
          employment = employment[0];
        }
        switch (employment) {
          case 'Hourly':
          case 'Salaried':
            return 'w2Branch';
          default:
            return null;
        }
      },
      continuation
    )
  );



// WEBPACK FOOTER //
// ./src/decks/branches/employment.js